import axios from "axios";
import { baseUrl } from "./config";

axios.defaults.baseURL = baseUrl;

const axFile = axios.create();

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

const handleLogout = () => {
  localStorage.clear();
  window.location.href = "/login";
};

axFile.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("accessToken");
    
    delete config.headers["Content-Type"];
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

axFile.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retryAuth
    ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return axFile(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retryAuth = true;
      isRefreshing = true;

      try {
        const refreshToken = localStorage.getItem("accessTokenRefresh");

        if (!refreshToken) {
          throw new Error("No refresh token");
        }

        const response = await axios.post(
          `${baseUrl}api/account/refreshToken`,
          {
            refreshToken: refreshToken,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const { accessToken, refreshToken: newRefreshToken } = response.data;

        if (!accessToken) {
          throw new Error("No access token received");
        }

        localStorage.setItem("accessToken", accessToken);
        if (newRefreshToken) {
          localStorage.setItem("accessTokenRefresh", newRefreshToken);
        }

        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        
        processQueue(null, accessToken);

        return axFile(originalRequest);
      } catch (refreshError) {
        handleLogout();
        processQueue(refreshError, null);
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default axFile;